import { render, staticRenderFns } from "./articledetails.vue?vue&type=template&id=2125c3cb"
import script from "./articledetails.vue?vue&type=script&lang=js"
export * from "./articledetails.vue?vue&type=script&lang=js"
import style0 from "./articledetails.vue?vue&type=style&index=0&id=2125c3cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports